import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/instances/$instanceId/packs')({
  component: PacksLayout,
})

function PacksLayout() {
  return <Outlet />
}
